/* global Option */
/**
 * Select2 initialization
 */

import 'select2'

$(() => {
    const defaultOptions = {
        language: {
            inputTooShort: function () {
                return 'Entrer un ou plusieurs caractères'
            },
            noResults: function () {
                return 'Pas de résultat'
            },
        },
        width: 'style',
        templateResult: function (option) {
            if (option.element && option.element.hasAttribute('hidden')) {
                return null
            }
            return option.text
        },
    }

    $('select.select2').select2(defaultOptions)

    $('select.ajax-select2').each(function () {
        const $select = $(this)
        const $modalContent = $select.closest('.modal-content')
        $select.select2({
            ...defaultOptions,
            ajax: {
                delay: 500,
                url: function () {
                    return $(this).data('url')
                },
                dataType: 'json',
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page || 1,
                        perPage: 25,
                    }
                },
                processResults: function (data, params) {
                    params.page = params.page || 1
                    const meta = data.meta || data
                    return {
                        results: data.data,
                        pagination: {
                            more: meta.current_page < meta.last_page,
                        },
                    }
                },
            },
            dropdownParent: $modalContent[0],
        })
    })

    $('select.select2').on('select2:selecting', function (event) {
        if ($(event.params.args.data.element).hasClass('select-all')) {
            const $select = $(event.target)
            event.preventDefault()

            $select.val(
                $select.find('option:not(.select-all)').map(function (index, option) {
                    return $(option).val()
                })
            )
            $select.trigger('change')
            $select.select2('close')
        }
    })

    $('select[data-mode="parentToChild"]')
        .on('change', function () {
            const $this = $(this),
                $target = $('#' + $(this).data('target-select')),
                $selected = $this.find(':selected')

            if ($target.find(':selected').length == 0) {
                if ($selected.val() == '') {
                    $target
                        .data('select2')
                        .$container.find('.select2-search__field')
                        .attr('placeholder', $target.data('undefined-placeholder') || 'Choisissez une catégorie')
                } else {
                    $target
                        .data('select2')
                        .$container.find('.select2-search__field')
                        .attr('placeholder', 'Choisissez un poste de la catégorie ' + $selected.text())
                }
            }

            $target.find('option:not(:disabled)').prop('disabled', true)

            if ($selected.val()) {
                $target.find('option[data-category=' + $selected.val() + ']').prop('disabled', false)
            }
        })
        .change()

    $('select.select2[data-bound-select=organization-center-recruiter]')
        .on('change', function () {
            const $this = $(this),
                $target = $($this.data('bound-to')),
                $selected = $this.find(':selected'),
                boundValue = $selected.data('bound-value')
            $target.find('option:not(:disabled)').prop('disabled', true)

            if ($selected.val()) {
                $target.find('option[data-binding-value=' + boundValue + ']').prop('disabled', false)
            }
        })
        .change()

    $('select.select2[data-bound-select=organization-hub-center]')
        .on('change', function () {
            const $this = $(this),
                $targets = $($this.data('bound-to')),
                $selected = $this.find(':selected'),
                boundValue = $selected.data('bound-value')
            $targets.find('option:not(:disabled)').prop('disabled', true)

            if ($selected.val()) {
                $targets.find('option[data-binding-value=' + boundValue + ']').prop('disabled', false)
            }
        })
        .change()

    // Filtre Agences & Associations
    $('select.select2[data-bound-select=agency-organization]')
        .on('change', function () {
            const $target = $($(this).data('bound-to')),
                selectedAgencies = $(this).val() || []

            $target.find('option:not(:disabled)').prop('disabled', true)

            if (selectedAgencies.length > 0) {
                $target.find('option').each(function () {
                    if (selectedAgencies.includes($(this).data('binding-value')?.toString())) {
                        $(this).prop('disabled', false)
                    }
                })
            } else {
                $target.find('option:disabled').prop('disabled', false)
            }
        })
        .change()

    // Filtre Agences & Etablissements
    $('select.select2[data-bound-select2=agency-center]').on('change', function () {
        const selectedAgencies = $(this).val() || []
        const $center = $('#JobFilterCenter')

        $center.find('optgroup, option').prop('disabled', true)

        if (selectedAgencies.length > 0) {
            $center.find('option').each(function () {
                if (selectedAgencies.includes($(this).data('binding-value2')?.toString())) {
                    $(this).prop('disabled', false)
                    $(this).parent().prop('disabled', false)
                }
            })
        } else {
            $center.find('optgroup, option').prop('disabled', false)
        }

        $center.trigger('change.select2')
    })

    // Filtre Association & Etablissements
    $('select.select2[data-bound-select=organization-center]')
        .on('change', function () {
            const $target = $($(this).data('bound-to')),
                $selected = $(this).find(':selected')
            if ($selected.val()) {
                $target.find('optgroup:not(:disabled)').prop('disabled', true)

                $target.find('option:not(:disabled)').prop('disabled', false)

                $selected.each((key, element) => {
                    const option = $target.find('option[data-binding-value=' + element.dataset.boundValue + ']')

                    option.prop('disabled', false)
                    option.parent().prop('disabled', false)
                })
            } else {
                $target.find('optgroup:disabled').prop('disabled', false)

                $target.find('option:disabled').prop('disabled', false)
            }
        })
        .change()

    $('#FilterLocation')
        .on('select2:select', function (e) {
            if (e.params.data.id.match(/^city:.*$/g)) {
                $('#FilterCityRange').addClass('d-block')
            } else {
                $('#FilterCityRange').removeClass('d-block')
            }

            $('#FilterHomeRange').addClass('d-none')
        })
        .on('select2:unselect', function () {
            $('#FilterHomeRange').removeClass('d-none')
            $('#FilterCityRange').removeClass('d-block')
        })

    function fetchRecruitersForCenter(centerId) {
        $.ajax({
            type: 'GET',
            url: route('api.admin.recruiter.index', {
                filters: {
                    centerIds: [centerId],
                },
            }),
        }).then(function (data) {
            $('#ApplicantSuggestionRecruitersToEmail').empty().trigger('change')

            $(data.data).each((index, item) => {
                $('#ApplicantSuggestionRecruitersToEmail')
                    .append(new Option(item.text, item.id, 0 === index, false))
                    .trigger('change')
            })
        })
    }

    $('#ApplicantSuggestionRecruitersToEmail').select2({
        minimumResultsForSearch: 'Infinite',
    })

    const selectedCenter = $('#ApplicantSuggestionCenter').find(':selected').val()
    if (selectedCenter) {
        fetchRecruitersForCenter(selectedCenter)
    }

    $('#ApplicantSuggestionCenter').on('select2:select', e => {
        fetchRecruitersForCenter(e.params.data.id)
    })
})
